import { render, staticRenderFns } from "./SplitPanelGroup.vue?vue&type=template&id=2ae51dfd"
import script from "./SplitPanelGroup.vue?vue&type=script&lang=js"
export * from "./SplitPanelGroup.vue?vue&type=script&lang=js"
import style0 from "./SplitPanelGroup.vue?vue&type=style&index=0&id=2ae51dfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports